import { Box, Card, Button, Theme, SxProps, FormControlLabel, Switch } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router';
// import { RedoIcon } from 'src/assets/icons/RedoIcon';
// import { UndoIcon } from 'src/assets/icons/UndoIcon';
import { useAllDashboardsContext } from 'src/contexts/allDashboardsContext/allDashboards.context';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';
import { useAuthentication } from 'src/features/authentication/context';
import { LeaveDashboardDialog } from '../leaveDashboardDialog/LeaveDashboardDialog';
import { useState } from 'react';

type Props = {
  sx?: SxProps<Theme>;
  handleClose?: () => void;
  isEdit?: boolean;
  setMode?: any;
};

export const HeaderControllerBar = ({ sx, handleClose, isEdit, setMode }: Props) => {
  const {
    createDashboardHandler,
    editDashboardHandler,
    nodes,
    title,
    showMiniMap,
    setShowMiniMap,
    resetToInitialNodes,
  } = useCustomDashboardContext();
  const { enqueueSnackbar } = useSnackbar();
  const [isDialog, setIsDialog] = useState<boolean>(false);
  const {
    customerId: { value: customerId },
  } = useAuthentication();
  const { dashboardId } = useParams();
  const navigate = useNavigate();

  const { addDashboardToState } = useAllDashboardsContext();

  const handleSave = async () => {
    const payloadData = nodes.map(({ selected, dragging, resizing, ...rest }) => rest);
    try {
      if (isEdit) {
        await editDashboardHandler({
          data: { nodes: payloadData, title, showMiniMap },
          customerId: customerId!,
          dashboardId: dashboardId!,
        });
        if (handleClose) handleClose();
      } else {
        const createdDashboard = await createDashboardHandler({
          data: { nodes: payloadData, title, showMiniMap },
          customerId: customerId!,
        });

        if (createdDashboard?.dashboardId) {
          addDashboardToState({
            dashboardId: createdDashboard.dashboardId,
            title,
          });
          navigate(`/preview-dashboard/${createdDashboard?.dashboardId}?customerId=${customerId}`);
        }
      }

      enqueueSnackbar('Dashboard successfully saved!', { variant: 'success' });
    } catch (error) {
      enqueueSnackbar('Failed to save dashboard', { variant: 'error' });
    }
  };

  const dialogText = isEdit
    ? 'Are you sure you want to close the dashboard editor. All unsaved changes will be lost.'
    : 'Are you sure you want to cancel the creation of this dashboard? All changes will be lost.';

  const onHandleClose = () => {
    // if (handleClose) handleClose();
    setIsDialog(true);
  };

  const onConfirmDialog = () => {
    if (isEdit) {
      setMode('preview');
      resetToInitialNodes();
    } else {
      navigate(`/sites-management?customerId=${customerId}`);
    }
  };

  return (
    <Card
      sx={{
        padding: '24px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', gap: '16px' }}>
        {/* <UndoIcon />
        <RedoIcon /> */}
        <FormControlLabel
          control={
            <Switch
              data-sm="show-mini-map-toggle"
              checked={showMiniMap}
              onChange={(event) => setShowMiniMap(event.target.checked)}
            />
          }
          label="Show Mini Map"
        />
      </Box>
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <Button
          sx={{
            color: (theme) => theme.palette.grey[500],
            borderColor: (theme) => theme.palette.grey[400],
            '&:hover': {
              backgroundColor: (theme) => theme.palette.grey[100],
              borderColor: (theme) => theme.palette.grey[500],
            },
          }}
          variant="outlined"
          onClick={onHandleClose}
        >
          {isEdit ? 'Close' : 'Cancel'}
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Save Dashboard
        </Button>
      </Box>
      <LeaveDashboardDialog
        isOpen={isDialog}
        onClose={() => setIsDialog(false)}
        text={dialogText}
        onConfirm={onConfirmDialog}
      />
    </Card>
  );
};
